export const formatMoneyWithoutCurrency = (price: number): string => {
  if (price === 0) return '0,00'

  const numPrice = price / 100
  const [integerPart, decimalPart] = numPrice.toFixed(2).split('.')

  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return `${formattedIntegerPart},${decimalPart}`
}
